import createGetFormNames from './selectors/getFormNames';
import plain from './structure/plain';

export default createGetFormNames(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormNames.js
// module id = 576
// module chunks = 0